module.exports = __webpack_public_path__ + "img/bangladeshphoto.67127448.jpg";